<div class="views">
  <chat-chats-sidenav class="view"></chat-chats-sidenav>
</div>
